import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_URL;

// export const baseUrl = 'https://42kicks.buzeto.cloud/api';
// export const baseUrl = "http://192.168.1.31:4000/api"
export const limit = 10;

const axiosInstance = axios.create({
  baseURL: baseUrl || '',
  timeout: 10000
});

axiosInstance.postWithBody = (url, body, config = {}) => {
  const isFormData = body instanceof FormData;
  return axiosInstance.post(url, body, {
    ...config,
    headers: {
      ...(config.headers || {}),
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
    }
  });
};
axiosInstance.deleteWithBody = (url, body, config = {}) => {
  return axiosInstance.request({
    method: 'DELETE',
    url,
    ...config,
    data: body
  });
};

axiosInstance.getWithParams = (url, params) => {
  return axiosInstance.get(url, { params });
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    } else {
      console.log('No token found!');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let _message = null;

export const setAxiosInterceptors = (msg) => {
  if (msg) _message = msg;
  if (axiosInstance.interceptors.response.handlers?.length) return;
  axiosInstance.interceptors.response.use(
    (response) => {
      const { config, status, data } = response;
      if (['post', 'put', 'delete', 'patch'].includes(config.method)) {
        if (status === 200 || status === 201) {
          _message?.success(data?.message || data?.data || 'Success');
        }
      }
      return response;
    },
    (error) => {
      const { response } = error;
      if (response) {
        const { status, data } = response;
        if (status === 401) {
          _message?.error('Unauthorized. Please log in again.');
          localStorage.removeItem('token');
          window.location.href = '/login';
        } else if (status === 400 || status === 403) {
          _message?.error(data?.message || 'Request not allowed.');
        } else if (status >= 500) {
          _message?.error('Server error. Try again later.');
        } else {
          _message?.error(data?.message || 'Something went wrong.');
        }
      } else {
        _message?.error('Network error. Please check your connection.');
      }
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
